import { registerAction } from '../../Action'
import { deserializeJson } from '../../jsonApiDeserializer'

const LOAD_CANVAS_SLIDE = 'LOAD_CANVAS_SLIDE'

const reducer = (state = {}, action) => ({
  ...deserializeJson({ payload: action.payload, state }),
})

const loadSlide = registerAction(LOAD_CANVAS_SLIDE, { reducer })

export default loadSlide
